import { Component, OnInit, OnDestroy, computed } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { MessageService } from 'primeng/api';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CustomValidator } from 'src/app/shared/custom-validator';
import { Constants } from 'src/app/shared/constants';
import { AdminSettingsService } from '../../servicies/admin-settings.service';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';
import { ResultOfT, Result } from 'src/app/shared/models/response/result';
import { SettingsPluginRequestModel } from 'src/app/shared/models/request/settings/settings-plugin-request-model';
import { SettingsPluginResponseModel, PluginEmailModel, MicrosoftOAuthConfigModel } from 'src/app/shared/models/response/settings/settings-plugin-response-model';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { SettingsResponseModel } from 'src/app/shared/models/response/appointment/settings-response';
import { SettingsRequestModel } from 'src/app/shared/models/request/settings/settings-request-model';
import moment from 'moment';
import { featureResponseModel } from 'src/app/shared/models/response/feature-group-response';
import { EmailProvideType } from 'src/app/interfaces/email-providers-enum';

@Component({
  selector: 'app-plugins',
  templateUrl: './plugins.component.html',
  styleUrls: ['./plugins.component.sass'],
  standalone: false
})
export class PluginsComponent extends BaseComponent implements OnInit, OnDestroy {
  private unsubscriber = new Subject<boolean>();
  private progress = new Subject<boolean>();
  settingsPluginResponseModel: SettingsPluginResponseModel;
  settingsPluginRequestModel: SettingsPluginRequestModel;
  pluginModel: PluginEmailModel;
  loggedInUserId: number;
  title = 'Plugin Settings';
  clientId: number;
  isVoiceCallRecordingDisplay: boolean = false;
  customStartTime: string;
  customEndTime: string;
  settingsResponseModel: Array<SettingsResponseModel>;
  settingsRequestModel: Array<SettingsRequestModel>;
  features: featureResponseModel[];
  isPaymentPermission: boolean = false;
  selectedAuthType: string;// = 'Basic';
  emailProviders = EmailProvideType;
  authTypeOptions = [
    { label: 'Basic Authentication', value: EmailProvideType.BASIC },
    { label: 'Microsoft', value: EmailProvideType.MICROSOFT },
    // { label: 'Google', value: EmailProvideType.GOOGLE }
  ];

  formFields = {
    authType: 'authType',
    fromEmailAddress: 'fromEmailAddress',
    fromName: 'fromName',
    smtpHost: 'smtpHost',
    smtpPort: 'smtpPort',
    typeOfEncryption: 'typeOfEncryption',
    smtpUsername: 'smtpUsername',
    smtpPassword: 'smtpPassword',
    // OAuth2 fields
    clientId: 'clientId',
    clientSecret: 'clientSecret',
    tenantId: 'tenantId',
    fromEmail: 'fromEmail'
  };

  validationMessages = {
    fromEmailAddress: {
      required: 'From Email Address is required',
      email: 'Enter valid from email address'
    },
    fromName: {
      required: 'From name is required'
      //validCharacters: 'Enter valid from name'
    },
    smtpHost: {
      required: 'SMTP host is required',
      validHostName: 'Enter valida host name'
    },
    smtpPort: {
      required: 'SMTP port is required',
      validNumber: 'Only numbers are allowed'
    },
    typeOfEncryption: {
      required: 'Type of encryption is required'
      //validCharacters: 'Enter valid contact name'
    },
    smtpUsername: {
      required: 'SMTP username is required'
      //validCharacters: 'Enter valid contact name'
    },
    smtpPassword: {
      required: 'SMTP password is required'
      //validCharacters: 'Enter valid contact name'
    },
    // OAuth Microsoft/Google validation messages
    clientId: {
      required: 'Client ID is required'
    },
    clientSecret: {
      required: 'Client Secret is required'
    },
    tenantId: {
      required: 'Tenant ID is required'
    },
    fromEmail: {
      required: 'From Email is required',
      email: 'Enter valid from email address'
    }
  };


  constructor(
    private router: Router,
    private webStorageService: WebStorageService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private settingsService: AdminSettingsService,
    messageService: MessageService
  ) {
    super(messageService);
    var clientdetail = this.webStorageService.getClientConfig();
    this.clientId = Number(clientdetail.companyId);

    var channelArray: Array<Number> = [9, 12, 7, 13, 14, 15, 18, 20, 21, 27, 31, 1008, 1011]; //Allow to use Nums and Preprod clients
    this.isVoiceCallRecordingDisplay = channelArray.includes(this.clientId) ? true : false;
  }

  ngOnDestroy(): void {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
    if (this.progress) {
      this.progress.complete();
    }
  }

  async ngOnInit() {
    this.buildForm();
    const loggedInUser = this.webStorageService.getCurrentUserToken();
    this.loggedInUserId = loggedInUser.userId;
    this.getPluginConfiguration();

    this.features = this.webStorageService.getPermissions();
    if (this.features != null && this.features != undefined) {
      if (this.features && this.features.length > 0) {
        let paymentFeature = this.features.find((x) => x.appModuleFeatureName.toLowerCase() == 'payment');
        if (paymentFeature && paymentFeature.isActive == true) this.isPaymentPermission = true;
        else this.isPaymentPermission = false;
      }
    }
  }

  private getPluginConfiguration(key: string = Constants.pluginSettingEmail) {
    this.loading = true;
    this.settingsService
      .getEmailProviderConfig(key)
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .subscribe(
        (result: ResultOfT<any>) => {
          this.processResult<any>(result, async () => {
            this.settingsPluginResponseModel = result.responseModel;
            this.setValuesToForm();
            await this.getApplicationSettings();
          });
        },
        (httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        }
      );
  }

  private async getApplicationSettings() {
    this.settingsService
      .getAllSettings()
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .subscribe(
        (result: ResultOfT<any>) => {
          this.processResult<any>(result, async () => {
            this.settingsResponseModel = result.responseModel;
            this.settingsResponseModel.forEach((x) => {
              if (x.schSettingKey == Constants.SettingKeys.EmailSendStartTime) this.customStartTime = moment(x.schSettingValue, 'HH:mm:ss').format('HH:mm');
              if (x.schSettingKey == Constants.SettingKeys.EmailSendEndTime) this.customEndTime = moment(x.schSettingValue, 'HH:mm:ss').format('HH:mm');
            });
          });
        },
        (httpResponseError) => {
          this.showErrorMessage(httpResponseError.message);
        }
      );
  }

  async onAuthTypeChange(event: any) {
    this.selectedAuthType = event.value;
    this.updateFormValidators();
    await this.getPluginConfiguration(this.selectedAuthType);
  }

  private updateFormValidators() {
    Object.keys(this.formFields).forEach(key => {
      if (key !== 'authType' && key !== 'typeOfEncryption') {
        this.form.get(key)?.clearValidators();
        this.form.get(key)?.updateValueAndValidity();
      }
    });

    if (this.selectedAuthType === this.emailProviders.BASIC) {
      // Set BasicAuth validators
      this.form.get(this.formFields.fromEmailAddress)?.setValidators([Validators.required, CustomValidator.whitespace, CustomValidator.email]);
      this.form.get(this.formFields.fromName)?.setValidators([Validators.required, CustomValidator.whitespace]);
      this.form.get(this.formFields.smtpHost)?.setValidators([Validators.required, CustomValidator.whitespace, CustomValidator.hostName]);
      this.form.get(this.formFields.smtpPort)?.setValidators([Validators.required, CustomValidator.whitespace, CustomValidator.onlyNumbers]);
      this.form.get(this.formFields.smtpUsername)?.setValidators([Validators.required, CustomValidator.whitespace]);
      this.form.get(this.formFields.smtpPassword)?.setValidators([Validators.required, CustomValidator.whitespace]);
    } else if (this.selectedAuthType === this.emailProviders.MICROSOFT) {
      // Set OAuth validators
      this.form.get(this.formFields.clientId)?.setValidators([Validators.required, CustomValidator.whitespace]);
      this.form.get(this.formFields.clientSecret)?.setValidators([Validators.required, CustomValidator.whitespace]);
      this.form.get(this.formFields.tenantId)?.setValidators([Validators.required, CustomValidator.whitespace]);
      this.form.get(this.formFields.fromEmail)?.setValidators([Validators.required, CustomValidator.whitespace, CustomValidator.email]);
    }

    // Update all form controls
    Object.keys(this.formFields).forEach(key => {
      this.form.get(key)?.updateValueAndValidity();
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.markFormAsTouched();
      return;
    }

    if (!this.customStartTime) {
      this.showWarningMessage('Please select Start Time.');
      return false;
    }
    if (!this.customEndTime) {
      this.showWarningMessage('Please select End Time.');
      return false;
    }

    if (this.customStartTime != undefined && this.customEndTime != undefined) {
      var _startTime = moment(this.customStartTime, 'hh:mm A').format('HH:mm');
      var _endTime = moment(this.customEndTime, 'hh:mm A').format('HH:mm');

      if (_endTime == _startTime) {
        this.showWarningMessage('Start Time & End Time should not be equal');
        return;
      } else if (_endTime < _startTime) {
        this.showWarningMessage('End Time should be greater than Start Time');
        return;
      }
    }

    var applicationPluginRequestModel = this.getValuesFromForm();
    const manageApplicationGeneral = this.settingsService.updatePluginConfiguration({ ...applicationPluginRequestModel, updateEmailProviderKey: true });

    this.loading = true;
    manageApplicationGeneral
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .subscribe(
        async (result: Result) => {
          this.loading = false;
          if (result && result.isSuccess) {
            await this.saveSettings();
            this.showSuccessMessage('Plugin Email settings is updated successfully');
          } else {
            this.showErrorMessage(result.message);
          }
        },
        (httpResponseError) => {
          this.loading = false;
          this.showErrorMessage(httpResponseError.message);
        }
      );
  }

  private async saveSettings() {
    var lstSettingsResponseModel = new Array<SettingsResponseModel>();

    var EmailSendStartTime = new SettingsResponseModel();
    EmailSendStartTime = this.settingsResponseModel.find((objWhere) => objWhere.schSettingKey == Constants.SettingKeys.EmailSendStartTime);
    EmailSendStartTime.schSettingValue = moment(this.customStartTime, 'hh:mm:ss').format('HH:mm:ss');
    EmailSendStartTime.dateTimeLastModified = new Date();
    EmailSendStartTime.modifiedByUserInfoId = this.loggedInUserId;
    lstSettingsResponseModel.push(EmailSendStartTime);

    var EmailSendEndTime = new SettingsResponseModel();
    EmailSendEndTime = this.settingsResponseModel.find((objWhere) => objWhere.schSettingKey == Constants.SettingKeys.EmailSendEndTime);
    EmailSendEndTime.schSettingValue = moment(this.customEndTime, 'hh:mm:ss').format('HH:mm:ss');
    EmailSendEndTime.dateTimeLastModified = new Date();
    EmailSendEndTime.modifiedByUserInfoId = this.loggedInUserId;
    lstSettingsResponseModel.push(EmailSendEndTime);

    const manageApplicationGeneral = this.settingsService.updateSettings(lstSettingsResponseModel);
    manageApplicationGeneral
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .subscribe(
        (result: Result) => {
          this.loading = false;
          if (result && result.isSuccess) {
          } else {
            this.showErrorMessage(result.message);
          }
        },
        (httpResponseError) => {
          this.loading = false;
          this.showErrorMessage(httpResponseError.message);
        }
      );
  }

  private getValuesFromForm(): SettingsPluginRequestModel {
    const form = this.form;
    var settingPluginRequestModel = new SettingsPluginRequestModel();
    settingPluginRequestModel = this.settingsPluginResponseModel;
    let microsoftOAuthConfig: MicrosoftOAuthConfigModel = null;
    // Set authentication type
    // this.pluginModel.AuthType = this.selectedAuthType;

    if (this.selectedAuthType === this.emailProviders.BASIC) {
      this.pluginModel.AutoResponderEmailAddress = form.get(this.formFields.fromEmailAddress).value;
      this.pluginModel.ContactName = form.get(this.formFields.fromName).value;
      this.pluginModel.SMTPServer = form.get(this.formFields.smtpHost).value;
      this.pluginModel.SMTPPort = form.get(this.formFields.smtpPort).value;
      this.pluginModel.SMTPUserName = form.get(this.formFields.smtpUsername).value;
      this.pluginModel.SMTPPassword = form.get(this.formFields.smtpPassword).value;
      this.pluginModel.EnableSsl = form.get(this.formFields.typeOfEncryption).value == 'SSL/TLS' || form.get(this.formFields.typeOfEncryption).value == 'STARTTLS' ? 'true' : 'false';
      this.pluginModel.EncryptionType = form.get(this.formFields.typeOfEncryption).value;
    } else if (this.selectedAuthType === this.emailProviders.MICROSOFT) {
      microsoftOAuthConfig = {
        EnableSsl: form.get(this.formFields.typeOfEncryption).value == 'SSL/TLS' || form.get(this.formFields.typeOfEncryption).value == 'STARTTLS',
        EncryptionType: form.get(this.formFields.typeOfEncryption).value,
        ClientId: form.get(this.formFields.clientId).value,
        ClientSecret: form.get(this.formFields.clientSecret).value,
        TenantId: form.get(this.formFields.tenantId).value,
        FromEmail: form.get(this.formFields.fromEmail).value
      };

    }



    settingPluginRequestModel.appPluginSettingsValue = JSON.stringify(this.selectedAuthType === this.emailProviders.BASIC ? this.pluginModel : microsoftOAuthConfig);
    settingPluginRequestModel.modifiedByUserInfoId = this.loggedInUserId;
    return settingPluginRequestModel;
  }

  private setValuesToForm() {
    this.form.reset();
    if (!this.settingsPluginResponseModel) {
      return;
    }
    let microsoftOAuthConfig: MicrosoftOAuthConfigModel = null;

    if (this.settingsPluginResponseModel.appPluginSettingsValue) {
      if (this.settingsPluginResponseModel.appPluginSettingsKey === this.emailProviders.BASIC) {
        this.pluginModel = JSON.parse(this.settingsPluginResponseModel.appPluginSettingsValue);
      } else if (this.settingsPluginResponseModel.appPluginSettingsKey === this.emailProviders.MICROSOFT) {
        microsoftOAuthConfig = JSON.parse(this.settingsPluginResponseModel.appPluginSettingsValue);
      }
    }
    const form = this.form;

    // Set authentication type - default to BasicAuth for existing records without AuthType
    this.selectedAuthType = this.settingsPluginResponseModel.appPluginSettingsKey;
    form.get(this.formFields.authType).setValue(this.selectedAuthType);
    form.get(this.formFields.authType).setValue(this.settingsPluginResponseModel.appPluginSettingsKey);
    if (this.selectedAuthType === this.emailProviders.BASIC) {

      form.get(this.formFields.fromEmailAddress).setValue(this.pluginModel.AutoResponderEmailAddress);
      form.get(this.formFields.fromName).setValue(this.pluginModel.ContactName);
      form.get(this.formFields.smtpHost).setValue(this.pluginModel.SMTPServer);
      form.get(this.formFields.smtpPort).setValue(this.pluginModel.SMTPPort);
      form.get(this.formFields.smtpUsername).setValue(this.pluginModel.SMTPUserName);
      form.get(this.formFields.smtpPassword).setValue(this.pluginModel.SMTPPassword);
      form.get(this.formFields.typeOfEncryption).setValue(this.pluginModel.EncryptionType || (this.pluginModel.EnableSsl == 'true' ? 'SSL/TLS' : 'None'));

    } else if (this.selectedAuthType === this.emailProviders.MICROSOFT) {
      form.get(this.formFields.clientId).setValue(microsoftOAuthConfig.ClientId);
      form.get(this.formFields.clientSecret).setValue(microsoftOAuthConfig.ClientSecret);
      form.get(this.formFields.tenantId).setValue(microsoftOAuthConfig.TenantId);
      form.get(this.formFields.fromEmail).setValue(microsoftOAuthConfig.FromEmail);
      form.get(this.formFields.typeOfEncryption).setValue(microsoftOAuthConfig.EncryptionType || (microsoftOAuthConfig.EnableSsl ? 'SSL/TLS' : 'None'));
    }


    this.updateFormValidators();
  }

  private buildForm() {
    const formGroup = this.formBuilder.group({});

    // Authentication Type dropdown
    formGroup.addControl(
      this.formFields.authType,
      this.formBuilder.control('', { validators: [Validators.required], updateOn: Constants.formControlUpdateStrategy.blur })
    );

    // BasicAuth fields
    formGroup.addControl(
      this.formFields.fromEmailAddress,
      this.formBuilder.control('', {
        validators: [],
        updateOn: Constants.formControlUpdateStrategy.blur
      })
    );
    formGroup.addControl(
      this.formFields.fromName,
      this.formBuilder.control('', { validators: [], updateOn: Constants.formControlUpdateStrategy.blur })
    );
    formGroup.addControl(
      this.formFields.smtpHost,
      this.formBuilder.control('', {
        validators: [],
        updateOn: Constants.formControlUpdateStrategy.blur
      })
    );
    formGroup.addControl(
      this.formFields.smtpPort,
      this.formBuilder.control('', {
        validators: [],
        updateOn: Constants.formControlUpdateStrategy.blur
      })
    );
    formGroup.addControl(
      this.formFields.smtpUsername,
      this.formBuilder.control('', { validators: [], updateOn: Constants.formControlUpdateStrategy.blur })
    );
    formGroup.addControl(
      this.formFields.smtpPassword,
      this.formBuilder.control('', { validators: [], updateOn: Constants.formControlUpdateStrategy.blur })
    );

    // OAuth2 fields
    formGroup.addControl(
      this.formFields.clientId,
      this.formBuilder.control('', { validators: [], updateOn: Constants.formControlUpdateStrategy.blur })
    );
    formGroup.addControl(
      this.formFields.clientSecret,
      this.formBuilder.control('', { validators: [], updateOn: Constants.formControlUpdateStrategy.blur })
    );
    formGroup.addControl(
      this.formFields.tenantId,
      this.formBuilder.control('', { validators: [], updateOn: Constants.formControlUpdateStrategy.blur })
    );
    formGroup.addControl(
      this.formFields.fromEmail,
      this.formBuilder.control('', { validators: [], updateOn: Constants.formControlUpdateStrategy.blur })
    );

    // Common field
    formGroup.addControl(
      this.formFields.typeOfEncryption,
      this.formBuilder.control('', { validators: [Validators.required], updateOn: Constants.formControlUpdateStrategy.blur })
    );

    this.form = formGroup;

    // Set initial validators for BasicAuth (default)
    this.updateFormValidators();
  }
}
